import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

export const LOCAL_IFRAME_SOURCE = '/iFramePlaceholder.html';
export const MATRIX_DESIGN_QUERY = '?SQ_DESIGN_NAME=iframe&SQ_PAINT_LAYOUT_NAME=iframe';
export const IFRAME_PARAMS = {
  SQ_DESIGN_NAME: 'iframe',
  SQ_PAINT_LAYOUT_NAME: 'iframe'
};

const countMatchingSegments = (segments1, segments2) => segments1.filter((segmentValue, segmentIndex) => (
  segmentValue === segments2[segmentIndex]
)).length;

// determine if provided URL contains fragments of documents tabs on page.
export const detectDocumentLink = anchorPaths => {
  if (
    anchorPaths.includes("tabs") &&
    anchorPaths.includes("documents-and-forms")
  ) {
    return true;
  } else if (
    anchorPaths.includes("tabs") &&
    anchorPaths.includes("documents")
  ) {
    return true;
  } else if (
    anchorPaths.includes("content") &&
    anchorPaths.includes("documents-and-forms")
  ) {
    return true;
  }
  return false;
};

// Get index of documents tab
export const findDocumentsTab = documentTabs => {
  let index = 0;
  const tab = documentTabs.filter((tab, key) => {
    if (tab.hasFiles) {
      index = key;
      return tab;
    }
  });
  return {
    tab: tab[0],
    index: index
  };
};

export const findSlugSection = (path, slugs) => {
  let matches = [];
  slugs.forEach(function(e) {
    e.subSections.filter(function(c) {
      if (c.slug === path) {
        matches = e;
      }
    });
  });
  return matches;
};

export const followLink = event => {
  const frame = document.querySelector("iframe#provider-drawer-frame");
  const targetValue = event.target.getAttribute("target");
  const targetHref = event.target.getAttribute("href");
  switch (targetValue) {
    case "_parent":
      window.parent.location = targetHref;
      break;
    case "_top":
      window.top.location = targetHref;
      break;
    case "_blank":
      const popup = window.open(targetHref, "_blank");
      popup.focus();
      break;
    default:
      frame.src = `${
        process.env.NODE_ENV === 'development'
          ? LOCAL_IFRAME_SOURCE
          : event.target.href + MATRIX_DESIGN_QUERY
      }`;
      break;
  }
};

/*
 * Set the iframe design and paint layout queries on
 * an existing URL.
 */
export const getFrameURL = link => {
  const iframeURL = new URL(link.href);
  const frameParams = new URLSearchParams(link.search);
  Object.keys(IFRAME_PARAMS).forEach(param => {
    frameParams.set(param, IFRAME_PARAMS[param]);
  });
  iframeURL.search = `?${frameParams}`;
  return iframeURL;
};

/*
 * Matrix does not always select the closest match when
 * selecting %asset_url%, so override the default URL with
 * the actual closest match.
 */
export const getMatchingURL = (urls, matchHREF, fallbackURL) => {
  const matchURL = new URL(matchHREF);
  const matchSegments = matchURL.pathname.split('/').slice(1);
  const matchingURL = urls.map(assetURL => {
    const url = new URL(assetURL);
    const segments = getValidSegments(url.pathname);
    // Origin counts as 3 matches: Protocol + Host + Port
    const countOrigin = url.origin === matchURL.origin ? 3 : 0;
    const countMatches = countOrigin + countMatchingSegments(segments, matchSegments);
    return({
      url: assetURL,
      countMatches: countMatches
    });
  }).sort((itemA, itemB) => (
    itemA.countMatches - itemB.countMatches
  )).reverse(
  ).find(item => (
    item.countMatches > 0
  ));
  return(!!matchingURL ? matchingURL.url : fallbackURL);
};

/*
 * Derive a flattened list of all provider process info (aka. subsections)
 * from a list of provider steps (aka. sections).
 */
export const getProviderProcessInfo = (sections, processInfo) => (
  sections.flatMap(section => (
    section.subSections.map(subSection => ({
        slug: subSection.slug,
        url: subSection.url
    }))
  ))
);

/*
* A Matrix path looks like this:
* providers/type/index/psychiatrists/achieving-outcomes/clinical-panel
* Strip out the invalid filler path segment to form a valid React app path:
* providers/type/psychiatrists/achieving-outcomes/clinical-panel
*/
export const getValidSegments = rawPath => {
  const rawSegments = rawPath.split('/').slice(1);
  return (rawSegments);
};

export const isDashboardURL = url => url.pathname.startsWith(`${process.env.REACT_APP_PATH}`);

export const isSameProvider = (url1, url2) => {
  const providerIndex = 2;
  const pathSegments1 = getValidSegments(url1.pathname);
  const pathSegments2 = getValidSegments(url2.pathname);
  if (!isDashboardURL(url1)
  || !isDashboardURL(url2)
  || pathSegments1.length <= providerIndex
  || pathSegments2.length <= providerIndex) {
  return false;
  }
  return(pathSegments1[providerIndex] === pathSegments2[providerIndex]);
};

// Close the drawer and scroll user to tab
export const navigateUser = anchorPaths => {
  document.querySelector(".provider-drawer__close-icon").click();
  if (document.querySelector(`.${anchorPaths[anchorPaths.length - 1]} .ant-collapse-header`)) {
    const scrollPos = document.querySelector(`.${anchorPaths[anchorPaths.length - 1]} .ant-collapse-header`).getBoundingClientRect().top + document.documentElement.scrollTop;
    document.querySelector(`.${anchorPaths[anchorPaths.length - 1]} .ant-collapse-header`).click();
    setTimeout(function() {
      window.scroll({
        top:scrollPos,
        left: 0,
        behavior: "smooth"
      });
    }, 200);
    return false;
  }
  const scrollPos = document.querySelector(`.provider-tabs`).getBoundingClientRect().top + document.documentElement.scrollTop;
  setTimeout(function() {
    window.scroll({
      top:scrollPos,
      left: 0,
      behavior: "smooth"
    });
  }, 200);
};
